module.exports = __webpack_public_path__ + "08d3f687dfb1291f40e12a845a9d0609.svg";